export default __webpack_public_path__ + "static/media/DashboardIcon.d4a64ec1.svg";